import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Construction, ArrowRight } from 'lucide-react';
import AdminLayout from '../../components/admin/AdminLayout';

const PlaceholderPage = ({ title, titleEn, icon: Icon, description }) => {
  const navigate = useNavigate();

  return (
    <AdminLayout>
      <div className="p-6 max-w-4xl mx-auto">
        <div className="bg-white rounded-xl shadow-sm border-2 border-gray-200 p-12 text-center">
          {/* Icon */}
          <div className="w-24 h-24 bg-gray-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
            {Icon ? (
              <Icon className="w-12 h-12 text-gray-400" strokeWidth={1.5} />
            ) : (
              <Construction className="w-12 h-12 text-gray-400" strokeWidth={1.5} />
            )}
          </div>

          {/* Title */}
          <h1 className="text-3xl font-black text-[#1E3A8A] mb-2">{title}</h1>
          {titleEn && (
            <p className="text-gray-500 mb-6">{titleEn}</p>
          )}

          {/* Description */}
          <div className="max-w-md mx-auto mb-8">
            <p className="text-gray-600 leading-relaxed">
              {description || 'هذا القسم قيد التطوير وسيكون متاحاً قريباً. جميع الميزات والوظائف سيتم تفعيلها تدريجياً.'}
            </p>
          </div>

          {/* Status Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 border border-blue-200 rounded-lg mb-8">
            <Construction className="w-5 h-5 text-blue-600" />
            <span className="text-sm font-bold text-blue-800">قيد التطوير</span>
          </div>

          {/* Back Button */}
          <div>
            <button
              onClick={() => navigate('/admin/dashboard')}
              className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-[#1E3A8A] to-[#1E40AF] text-white rounded-lg font-bold hover:shadow-lg transition-all"
            >
              <ArrowRight className="w-5 h-5" />
              <span>العودة للوحة التحكم</span>
            </button>
          </div>

          {/* Footer Note */}
          <div className="mt-8 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              💡 يتم العمل على إضافة جميع الميزات تدريجياً وفق خطة التطوير
            </p>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default PlaceholderPage;